var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"form-item",attrs:{"disabled":_vm.disabled,"value":_vm.value,"placeholder":"Select"},on:{"change":(e) => _vm.$emit('change', e)}},_vm._l((_vm.statusOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }